import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Wrapper = styled('div')`
    background-color: inherit;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
`

export const Body = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    padding-top: 8px;
    overflow: hidden;
`

export const DetailsSection = styled('section')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 0 0 auto;
`

export const TechnologiesSection = styled('section')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 0 0 auto;
`

export const IssuesSection = styled('section')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1 1 auto;
    min-height: 0;
`

export const IssuesTableHost = styled('div')`
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
`

export const SectionDivider = styled('hr')<{ theme?: TTheme }>`
    border: none;
    border-top: 1px solid
        ${({ theme }) => theme.colors.semantic.drawerSeparator};
    margin: 0;
    flex: 0 0 auto;
`
